<template>
  <a-list
    class="list"
    :loading="loading"
    itemLayout="horizontal"
    :pagination="pagination"
    :dataSource="results"
  >
    <a-collapse
      slot="renderItem"
      slot-scope="item"
      :bordered="false"
      class="fluid"
    >
      <a-collapse-panel
        :key="item.id"
        :header="`${item.formatted_date} ${item.formatted_time}`"
      >
        <a-steps class="steps" :current="item.history.current_step - 1">
          <span slot="progressDot" slot-scope="{ index, status, prefixCls }">
            <span
              :class="`${prefixCls}-icon-dot`"
              :style="{ backgroundColor: item.history.steps[index].dot_color }"
            />
          </span>
          <a-step
            v-for="(step, i) in item.history.steps"
            :key="i"
            :title="step.title"
            :description="step.description"
          />
        </a-steps>
        <p v-if="item.reason_for_not_being_present">
          <strong>Powód:</strong> {{ item.reason_for_not_being_present }}
        </p>
        <a-tag
          v-if="item.tag"
          slot="extra"
          :color="item.tag.color"
          v-text="item.tag.label"
        />
      </a-collapse-panel>
    </a-collapse>
  </a-list>
</template>

<script>
export default {
  props: {
    results: Array,
    pagination: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  margin-top: 40px;
}

.steps {
  margin-top: 24px;
}

::v-deep .ant-steps-item-description {
  font-size: 13px;
}
</style>
